import { assignmentErrorMessages } from '@repo/lib/messages/assignmentErrorMessages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { CreateAssignmentInput } from './assignmentService';

import { AssignmentService } from './assignmentService';
import { invalidateAssignedAssignments } from './invalidateAssignedAssignments';

export function useCreateAssignment() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateAssignmentInput) => AssignmentService.createAssignment(input).then((response) => response.data),
    onSuccess: () => invalidateAssignedAssignments(queryClient),
  });

  const errorMessage = useErrorMessage(mutation.error, assignmentErrorMessages);

  return { ...mutation, errorMessage };
}
